<template>
  <v-container fluid>
    <v-row>
      <v-col v-for="(item, index) in items" :key="index" sm="3">
        <MealCard
          :item="item"
          @deleteItem="askDeleteGericht"
          @editItem="editItem"
          @infoItem="infoItem"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import MealCard from "@/components/meals/MealCard.vue";

export default {
  name: "MealCardList",
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  data: () => ({}),
  components: { MealCard },
  methods: {
    askDeleteGericht(item) {
      this.$emit("deleteItem", item);
    },
    editItem(item) {
      this.$emit("editItem", item);
    },
    infoItem(item) {
      this.$emit("infoItem", item);
    }
  },

  computed: {
    kategorien() {
      return this.$store.getters["meal/getKategorien"];
    },
    mealSearch() {
      return this.$store.getters["meal/getMealSearch"];
    }
  },

  created() {}
};
</script>

<style scoped>
#Gerichtlistcard {
  margin: 20px;
}
</style>
